import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const alignmentClassMap = {
  left: 'character-limit-counter-align-left',
  center: 'character-limit-counter-align-center',
  right: 'character-limit-counter-align-right'
};

const CharacterLimitCounter = ({
  limit,
  count,
  onLimitReached,
  prefix = '+',
  className = '',
  counterClassName = '',
  limitReachedClassName = '',
  align = 'right'
}) => {
  const remaining = limit - count;
  const isLimitReached = remaining <= 0;
  const alignmentClass = alignmentClassMap[align] || alignmentClassMap.right;

  useEffect(() => {
    if (isLimitReached && typeof onLimitReached === 'function') {
      onLimitReached();
    }
  }, [isLimitReached, onLimitReached]);

  return (
    <div
      className={['character-limit-counter-root', alignmentClass, className].filter(Boolean).join(' ')}
      data-testid="character-limit-counter"
      aria-live="polite"
      aria-atomic="true"
      role="status"
    >
      <span className={['character-limit-count', counterClassName, isLimitReached ? limitReachedClassName : ''].filter(Boolean).join(' ')}>
        {isLimitReached ? '' : prefix}
        {remaining > 0 ? remaining : 0}
      </span>
    </div>
  );
};

CharacterLimitCounter.propTypes = {
  limit: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  onLimitReached: PropTypes.func,
  prefix: PropTypes.string,
  className: PropTypes.string,
  counterClassName: PropTypes.string,
  limitReachedClassName: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right', 'center'])
};

export default CharacterLimitCounter;
